import Api from "@/service/api";
import { AxiosRequestConfig } from "axios";
// import { Captcha, VerifyType } from "./enum";
// import { CaptchaInterface } from "./interface";

// 首页所有模块
// export async function productAssociationModule(options: AxiosRequestConfig) {
//   return Api.request({
//     url: "product/productAssociationModule",
//     method: "POST",
//     params: {},
//     ...options
//   });
// }

// 商品类目树
export async function produCtcategoryTree(options: AxiosRequestConfig) {
  return Api.request({
    url: "product/category/tree",
    method: "POST",
    params: {},
    ...options
  });
}

// // 首指定模块商品
// export async function associationModuleProduct(options: AxiosRequestConfig) {

//   return Api.request({
//     url: "product/associationModuleProduct",
//     method: "POST",
//     params: {},
//     data: {},
//     ...options
//   });
// }

// // 首页最近浏览商品
export async function productRecentView(options: AxiosRequestConfig) {

  return Api.request({
    url: "product/productRecentView",
    method: "POST",
    params: {},
    ...options
  });
}

// 商品详情
export async function productDetail(data: { itemCode: string }) {
  return Api.request({
    url: "product/productDetail",
    method: "POST",
    data
  });
}

// 商品搜索
export async function searchProduct(data: {}) {
  return Api.request({
    url: "search/search-product",
    method: "POST",
    data,
  });
}


// 商品评论
export async function productReviewPage(data: {
  productId: string,
  pageSize: number,
  current: number,
  sort?: number
}) {

  return Api.request({
    url: "product/review/list",
    method: "POST",
    data
  });
}

// 排名商品查询
export async function relativeProduct<T>(data: {
  spuCode: string,
  category: string
}) {
  return Api.request<T>({
    url: "search/relative-product",
    method: "POST",
    data
  });
}

